import { pressLogos, pressMentions, salon } from '../../data/content';

/**
 * "Aanbevolen in": logo's en namen van media, op shell (het toonverschil scheidt, geen randlijnen).
 * Zonder vermeldingen niets. Op de homepage staat pers in de feitenregel van de hero.
 */
export function PressStrip() {
  if (pressLogos.length === 0 && pressMentions.length === 0) return null;
  return <section aria-label={`Media over ${salon.name}`} className="bg-shell" data-id="element-8704" data-mp="23ghot7oxshm8">
      <div className="mx-auto flex max-w-content flex-col items-center gap-6 px-6 py-12 lg:flex-row lg:justify-between lg:gap-12 lg:px-10" data-id="element-8705" data-mp="15s7p4zcmi5ya">
        <p className="whitespace-nowrap text-[14px] text-muted" data-id="element-8706" data-mp="1fou81ile2mxo">Aanbevolen in</p>
        <ul className="flex flex-wrap items-center justify-center gap-x-10 gap-y-5 sm:gap-x-14" data-id="element-8707" data-mp="1fqx4akd4xcau">
          {pressLogos.map(logo => <li key={logo.name} data-id="element-8708" data-mp="2r4ivsc6gvpzj">
              <img src={logo.image} alt={logo.name} loading="lazy" className={`${logo.size === 'lg' ? 'h-10 sm:h-12' : 'h-6 sm:h-7'} w-auto opacity-80 mix-blend-multiply`} data-id="element-8709" data-mp="2r3g4421bljik" />
            </li>)}
          {pressMentions.map(name => <li key={name} className="font-display text-lg text-muted sm:text-xl" data-id="element-8710" data-mp="c99opapqu600">
              {name}
            </li>)}
        </ul>
      </div>
    </section>;
}